module.exports = __webpack_public_path__ + "img/open_data_button.83d2d865.png";